// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "table.table[data-v-0ce0c0ad] {\n  margin-bottom: 0;\n}", ""]);
// Exports
module.exports = exports;
